"use strict";

exports.__esModule = true;
exports.hashMessage = hashMessage;
/**
 * Generate a unique hash for a message.
 */
function hashMessage(prefix, message) {
  var hash = 0x811c9dc5;
  for (var i = 0; i < message.length; i++) {
    hash ^= message.charCodeAt(i);
    hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
  }
  return prefix + ":" + (hash >>> 0).toString(16);
}